// Shared parsing helpers for commander text. The frontend chat panel and the
// backend agent both receive raw LLM output that may carry a trailing strategy
// JSON payload or be a pure JSON object; these helpers strip/extract it. Kept in
// one place so the two consumers cannot drift apart.

const STRATEGY_KEY_PATTERN =
  /\{\s*"(?:intent|targetSector|maneuver|squad|targetLanes|spawnCommands|strategyType|requestedEvent|waveIntent|difficultyDelta|reason)"/;

/** Remove a trailing fenced/strategy JSON payload, leaving the human-facing text. */
export function stripStrategyPayload(text: string): string {
  const withoutFence = text.replace(/```(?:json)?[\s\S]*$/i, "");
  const strategyJson = withoutFence.search(STRATEGY_KEY_PATTERN);
  if (strategyJson >= 0) {
    return withoutFence.slice(0, strategyJson);
  }
  const looseJson = withoutFence.search(/\n\s*\{/);
  return looseJson >= 0 ? withoutFence.slice(0, looseJson) : withoutFence;
}

/** Parse text only if it is a complete JSON object; otherwise undefined. */
export function extractStrictJsonObject(text: string): unknown {
  if (!text.startsWith("{") || !text.endsWith("}")) return undefined;
  try {
    return JSON.parse(text) as unknown;
  } catch {
    return undefined;
  }
}
